// extracted by mini-css-extract-plugin
export default {"container":"XJ-z","topReviewHeading":"YJ-z","criticalReview":"ZJ-z","favorableReview":"_J-z","vsSeparator":"aK-z"};